<template>
    <div class="row recent-orders">
        <div class="col-sm-12 col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-2">
                    <div class="card border">
                        <div class="card-body text-center">
                            <h5>
                                Orders This Month: {{ totalOrders.month_count }}
                            </h5>
                            <h5>
                                ${{
                                    $filters.moneyFormat(
                                        totalOrders.month_total
                                    )
                                }}
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5>Open Orders: {{ totalOrders.open_count }}</h5>
                            <h5>
                                ${{
                                    $filters.moneyFormat(totalOrders.open_total)
                                }}
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="card border">
                        <div class="card-body text-center">
                            <h5>
                                Orders This Year: {{ totalOrders.year_count }}
                            </h5>
                            <h5>
                                ${{
                                    $filters.moneyFormat(totalOrders.year_total)
                                }}
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-auto">
                    <div v-if="currentLocation.id != 0" class="card border">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-auto">
                                    <label class="m-0">FFL Expiry:</label>
                                    <div>
                                        <b>{{
                                            currentLocation.ffl_expiry_date
                                        }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">FFL #:</label>
                                    <div>
                                        <b>{{ currentLocation.ffl_number }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">FFL EIN:</label>
                                    <div>
                                        <b>{{ currentLocation.ffl_ein }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-auto">
                                    <label class="m-0">SOT Expiry:</label>
                                    <div>
                                        <b>{{
                                            currentLocation.sot_expiry_date
                                        }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">SOT #:</label>
                                    <div>
                                        <b>{{ currentLocation.sot_number }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-auto">
                                            <label class="m-0">
                                                Upload SOT
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            name="sotupload"
                                            class="file-upload"
                                            @change="onChangeSot"
                                        />
                                        <button
                                            class="btn btn-action upload-btn"
                                        >
                                            Upload
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-auto">
                                            <label class="m-0">
                                                Upload FFL
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            name="fflupload"
                                            class="file-upload"
                                            @change="onChangeFfl"
                                        />
                                        <button
                                            class="btn btn-action upload-btn"
                                        >
                                            Upload
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3"></div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12">
            <br />
            <Orders
                header-title="Pending Orders"
                set-status="Pending"
                :page-type="'dashboard'"
                :page-type2="false"
            />
            <br />
            <Orders
                header-title="Open Orders"
                set-status="Open"
                :page-type="'dashboard'"
                :page-type2="false"
            />
            <br />
            <Invoices :page-type="'dashboard'" :page-type2="true" />
        </div>

        <div class="col-sm-12 col-md-2">
            <!-- <h5 class="mb-0 mt-5">FFL / SOT</h5>
            <hr>
            <div class="row">
                <div class="col-md-4">
                    <label>FFL Expiry:</label>
                </div>
                <div class="col-md-8">
                    <b>{{ currentLocation.ffl_expiry_date }}</b>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>SOT Expiry:</label>
                </div>
                <div class="col-md-8">
                    <b>{{ currentLocation.sot_expiry_date }}</b>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>FFL #:</label>
                </div>
                <div class="col-md-8">
                    <b>{{ currentLocation.ffl_number }}</b>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>SOT #:</label>
                </div>
                <div class="col-md-8">
                    <b>{{ currentLocation.sot_number }}</b>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <label>FFL EIN:</label>
                </div>
                <div class="col-md-8">
                    <b>{{ currentLocation.ffl_ein }}</b>
                </div>
            </div>
            <h5 class="mb-0 mt-4">Contact Your Representative</h5>
            <hr>
            <p class="mb-0">Your account representative is:</p>
			<div>
                <b>{{ currentLocation.sales_rep?.first_name }} {{ currentLocation.sales_rep?.last_name }}</b>
            </div>
            <div>
                <a class="text-decoration-none" href="tel:{{ currentLocation.sales_rep?.phone }}"><b>{{ currentLocation.sales_rep?.phone }}</b></a>
            </div>
            <div>
                <a class="text-decoration-none" href="mailto:{{ currentLocation.sales_rep?.email }}"><b>{{ currentLocation.sales_rep?.email }}</b></a>
            </div>
             -->
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import Orders from "@/components/orders/Orders.vue";
import Invoices from "@/components/invoices/Invoices.vue";

export default {
    props: [],
    emits: [],
    components: {
        Orders,
        Invoices,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let totalOrders = computed(function () {
            return store.state.totalOrders;
        });

        onMounted(() => {});

        return {
            store,
            user,
            currentLocation,
            totalOrders,
        };
    },
    data() {
        return {
            sotFile: [],
            fflFile: [],
            sotTmp: "",
            fflTmp: "",
        };
    },
    mounted() {
        this.store.dispatch("getTotalOrders", {
            location_id: this.currentLocation.id,
        });

        this.getLocationFiles();
    },
    methods: {
        // moneyFormat(val) {
        // 	return (parseFloat(val).toFixed(2)).toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
        // }
        goToOrder() {
            this.$router.push({ name: "orders", query: { filter: "open" } });
        },

        getLocationFiles() {
            axios
                .get("/api/get-location-files/" + this.currentLocation.id)
                .then((response) => {
                    let data = response.data;
                    if (data != undefined) {
                        data.forEach((item) => {
                            switch (item.type) {
                                case "SOT":
                                    this.sotTmp = item.file_name;
                                    console.log(this.sotTmp);
                                    break;
                                case "FFL":
                                    this.fflTmp = item.file_name;
                                    break;
                            }
                        });
                    }
                })
                .finally(() => {});
        },

        onChangeSot(e) {
            window.emitter.emit("changeLoaderStatus", true);
            var myFile = e.target.files[0].name;
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                this.sotFile = e.target.files;
                const formData = new FormData();
                formData.append("attachment", this.sotFile[0]);
                formData.append("location_id", this.currentLocation.id);
                formData.append("type", "SOT");
                axios
                    .post("/api/upload-location-file", formData)
                    .then((response) => {})
                    .finally(() => {
                        window.emitter.emit("changeLoaderStatus", false);

                        window.emitter.emit("alertSuccess", {
                            message: "Successfully uploaded and will be reviewed soon.",
                        });
                    });
            } else {
                this.sotFile = [];
                $("input[name=sotupload]").val("");
            }
        },
        onChangeFfl(e) {
            var myFile = e.target.files[0].name;
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                this.fflFile = e.target.files;
                const formData = new FormData();
                formData.append("attachment", this.fflFile[0]);
                formData.append("location_id", this.currentLocation.id);
                formData.append("type", "FFL");
                axios
                    .post("/api/upload-location-file", formData)
                    .then((response) => {})
                    .finally(() => {
                        window.emitter.emit("changeLoaderStatus", false);

                        window.emitter.emit("alertSuccess", {
                            message: "Successfully uploaded and will be reviewed soon.",
                        });
                    });
            } else {
                this.fflFile = [];
                $("input[name=sotupload]").val("");
            }
        },
    },
};
</script>
